const IntentHome = () => import('@/components/Intents/intent.templete.vue')
const EntitiesHome = () => import('@/components/Entities/entity.template.vue')
const ReviewHome = () => import('@/components/review/review.template.vue')

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.token) {
    console.log('tets token in store', localStorage.token)
    next()
    return
  }
  next()
}

import IntentRouter from './intent.router.js'
import EntityRouter from './entity.router.js'
import ReviewRouter from './review.router.js'

export default [

  {
    path: 'intents',
    component: IntentHome,
    meta:{
      title: 'build'
    },
    children: IntentRouter,
    beforeEnter: ifAuthenticated
  },
  {
    path: 'review',
    component: ReviewHome,
    meta:{
      title: 'build'
    },
    children: ReviewRouter,
    beforeEnter: ifAuthenticated
  },
  {
    path: 'entities',
    component: EntitiesHome,
    meta:{
      title: 'build'
    },
    children: EntityRouter,
    beforeEnter: ifAuthenticated
  }
]


// WEBPACK FOOTER //
// ./src/router/build.router.js